import { Button, styled } from '@mui/material';

export const ButtonDelete = styled(Button)({
  borderRadius: 'var(--border-radius-huge)',
  minWidth: 0,
  padding: 'var(--spacing-tiny)',
});
